module.exports = __webpack_public_path__ + "static/img/reward_icon_02.9813a0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/reward_icon_02.png
// module id = YWUQ
// module chunks = 1